import { remoteRoleToUserRole } from "../enums/SDKUserRole";
import { Workspace } from "../workspaces/SDKWorkspace";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class Membership {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.workspace = new Workspace(model.workspace);
        this.role = remoteRoleToUserRole[model.role];
        this.effectiveRole = remoteRoleToUserRole[model.effectiveRole];
        this.seatType = model.seatType;
        this.effectiveSeatType = model.effectiveSeatType;
        this.isDeactivated = model.isDeactivated;
    }
}
